import { render } from "./EditEmployeeDetails.vue?vue&type=template&id=512b2332"
import script from "./EditEmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EditEmployeeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__